/**
 * Pre-consent Dreamdata pipeline (cdn.drda.io). IP-to-company attribution only. Track calls are
 * allowed here after PII scrubbing in dreamdataRouter; there is no identify() - the cookieless
 * vendor library does not support it, and this app must never send traits down this pipeline.
 *
 * The cookieless snippet, once injected by dreamdataBootstrap.js, provides its own internal
 * queueing (via the vendor stub) until its async library finishes loading, so calls here don't
 * need a queue of our own.
 */
function track(eventName, props) {
  try {
    if (!window['dreamdata-cl']) {
      return;
    }
    window['dreamdata-cl'].track(eventName, props);
  } catch (e) {
    // Swallow - Dreamdata must never break signup.
  }
}

function page(...args) {
  try {
    if (!window['dreamdata-cl']) {
      return;
    }
    window['dreamdata-cl'].page(...args);
  } catch (e) {
    // Swallow - Dreamdata must never break signup.
  }
}

export default { track, page };
